export default "__VITE_ASSET__2fc9eb74__"